import { Stack, Typography } from '@mui/material'

export default function InfoAnaliseCredito({
  resposta
}: InfoAnaliseCreditoProps) {

  const safeText = (value?: string | null) => {
    return value?.trim() || '-'
  }

  return (
    <>
      <Stack direction={'column'} spacing={1} mt={2}>
        <Typography variant='caption'><b>Tipo operação:</b> {safeText(resposta?.tipo_operacao)}</Typography>
        <Typography variant='caption'><b>Necessário avalista:</b> {safeText(resposta?.necessario_avalista)}</Typography>
        <Typography variant='caption'><b>Necessário registro:</b> {safeText(resposta?.necessario_registro)}</Typography>
      </Stack>
    </>
  )
}

interface InfoAnaliseCreditoProps {
  resposta: any
}